/* eslint-disable import/prefer-default-export */
import React from 'react';

import { MDText } from 'i18n-react';

import { ExampleDocuments } from './ExampleDocuments/ExampleDocuments';
import { EXAMPLE_DOCUMENTS } from './ExampleDocuments/ExampleDocuments.helpers';
import { useImageManager } from './hooks/useImageManager';
import LocalTextsDRFT from './UploadDocumentsDRFT.texts.json';

import styles from './UploadDocumentsSummarySection.scss';

export const UploadDocumentsSummarySection = () => {
  const LocalT = new MDText(LocalTextsDRFT);

  const {
    hasUploadedDocuments,
    kind,
  } = useImageManager();

  const hasExampleDocuments = Boolean(EXAMPLE_DOCUMENTS[kind as keyof typeof EXAMPLE_DOCUMENTS]);

  const summaryText = LocalT.translate(`pages.${kind}.text`) as string;
  const summaryTitle = LocalT.translate(`pages.${kind}.summarytitle`, { notFound: null }) as string;
  const summaryList = kind ? LocalTextsDRFT.pages[kind]?.summary : undefined;

  const title = LocalT.translate(`pages.${kind}.title`) as string;
  const titleExampleDocuments = LocalT.translate(`pages.${kind}.titleExampleDocuments`) as string;
  const modalDescription = LocalT.translate(`pages.${kind}.modalText`, { notFound: null }) as string;

  const actionLink = hasUploadedDocuments ? LocalT.translate('unableToAcceptText.seeExample') : LocalT.translate('exampleDocuments.learnMore');

  return (
    <section className={styles.uploadDocumentsSummarySection}>
      <h2 className={styles.summaryTitleDRFT}>{title}</h2>
      <>
        <div className={styles.summaryTextContainer}>
          <p className={styles.summaryText}>{summaryText}</p>
          {hasExampleDocuments && <ExampleDocuments
            {...EXAMPLE_DOCUMENTS[kind as keyof typeof EXAMPLE_DOCUMENTS] as Record<string, unknown>}
            actionLink={actionLink as string}
            documentTitle={titleExampleDocuments}
            modalDescription={modalDescription}
          />}
        </div>
        <p className={styles.summaryListTitle}>{summaryTitle}</p>
        <ul className={styles.summaryList}>
          {summaryList && summaryList.map((summaryItem: string) => (
            <li key={summaryItem}>{summaryItem}</li>
          ))}
        </ul>
      </>
    </section>
  );
};
